import { Control, FieldErrors } from 'react-hook-form';
import { Field, Option, makeStyles, tokens } from '@fluentui/react-components';

import { ControlledField } from '@shared/components';

import { TAttachment } from '../../models';
import { TRequestFormData } from '../../validation';
import { MockUploadList, SectionCard } from '../shared';

const useStyles = makeStyles({
  fields: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalL, maxWidth: '720px' },
});

const identity = (value: string): string => value;

type TProps = {
  control: Control<TRequestFormData>;
  errors: FieldErrors<TRequestFormData>;
  readOnly: boolean;
  attachments: TAttachment[];
  onAddAttachment: () => void;
  onRemoveAttachment: (id: string) => void;
  relatedChangeOptions: string[];
};

export const SupportingInformationSection = ({
  control,
  errors,
  readOnly,
  attachments,
  onAddAttachment,
  onRemoveAttachment,
  relatedChangeOptions,
}: TProps) => {
  const classes = useStyles();
  return (
    <SectionCard title="Supporting information" description="Optional attachments and related changes." collapsible>
      <div className={classes.fields}>
        <Field label="Attachments">
          <MockUploadList
            attachments={attachments}
            onAdd={onAddAttachment}
            onRemove={onRemoveAttachment}
            disabled={readOnly}
          />
        </Field>

        <ControlledField
          name="relatedChanges"
          control={control}
          errors={errors}
          inputType="dropdown"
          label="Related changes"
          readonly={readOnly}
          multiselect
          getLabel={identity}
          placeholder="Link related changes"
        >
          {relatedChangeOptions.map((option) => (
            <Option key={option} value={option} text={option}>
              {option}
            </Option>
          ))}
        </ControlledField>
      </div>
    </SectionCard>
  );
};
